module.exports = __webpack_public_path__ + "static/media/trucks-without-background.c3cbac4a.png";